export default __webpack_public_path__ + "static/media/house-circe.8e442233.svg";